<template>
  <div class="p-4 bg-white">
    <b-form @submit.prevent="onSubmit">
      <!-- Tabs -->
      <b-row class="mb-5">
        <b-col md="12">
          <CustomNav :items="tabs" @item-click="(tab) => (activeTab = tab)" />
        </b-col>
      </b-row>

      <b-row v-if="activeTab == 'general'">
        <!-- LEFT COLUMN -->
        <b-col md="6">
          <!-- Account Info -->
          <section class="mb-4">
            <div class="section-title">
              <h6>ACCOUNT INFO</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Account Name *">
                  <b-form-input
                    v-model="form.accountName"
                    plain
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Vendor Class *">
                  <b-form-select
                    plain
                    v-model="form.vendorClass"
                    :options="vendorClassOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Vendor Category *">
                  <b-form-select
                    plain
                    v-model="form.vendorCategory"
                    :options="vendorCategoryOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Vendor Status *">
                  <b-form-select
                    required
                    v-model="form.vendorStatus"
                    :options="vendorStatusOptions"
                    plain
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </section>

          <!-- Account Address -->
          <section class="mb-5">
            <div class="section-title">
              <h6>ACCOUNT ADDRESS</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Country *">
                  <b-form-select
                    required
                    v-model="form.country"
                    :options="countryOptions"
                    plain
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Province *">
                  <b-form-input
                    required
                    plain
                    v-model="form.province"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="City *">
                  <b-form-input required v-model="form.city"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="District *">
                  <b-form-input v-model="form.district" required></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Sub District">
                  <b-form-input v-model="form.subDistrict"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Postal Code">
                  <b-form-input v-model="form.postalCode"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="Address">
              <b-form-textarea
                v-model="form.address"
                rows="2"
              ></b-form-textarea>
            </b-form-group>
          </section>

          <!-- Financial -->
          <section class="mb-4">
            <div class="section-title">
              <h6>FINANCIAL</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Terms">
                  <b-form-input v-model="form.terms"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Currency *">
                  <b-form-select
                    v-model="form.currency"
                    :options="currencyOptions"
                    required
                    plain
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </section>
        </b-col>

        <!-- RIGHT COLUMN -->
        <b-col md="6">
          <!-- Additional Account Info -->
          <section class="mb-4">
            <div class="section-title">
              <h6>ADDITIONAL ACCOUNT INFO</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Logo">
                  <b-form-file
                    v-model="form.logo"
                    browse-text="Browse"
                  ></b-form-file>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Web">
                  <b-form-input v-model="form.web"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </section>

          <!-- Primary Contact -->
          <section class="mb-4">
            <div class="section-title">
              <h6>PRIMARY CONTACT</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Name">
                  <b-form-input v-model="form.picName"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Job Title">
                  <b-form-input v-model="form.picJobTitle"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Email Office">
                  <b-form-input v-model="form.emailOffice"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Email">
                  <b-form-input v-model="form.email"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Phone">
                  <b-form-input v-model="form.phone"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Mobile Phone">
                  <b-form-input v-model="form.mobile"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </section>

          <!-- Additional Info -->
          <section class="mb-4">
            <div class="section-title">
              <h6>ADDITIONAL INFO</h6>
            </div>
            <b-row>
              <b-col md="6">
                <b-form-group label="NPWP Number">
                  <b-form-input v-model="form.npwp"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="SKTD Number">
                  <b-form-input v-model="form.sktd"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="NIB Number">
                  <b-form-input v-model="form.nib"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Bank">
                  <b-form-select
                    v-model="form.bank"
                    :options="bankOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group label="Bank Account Number">
                  <b-form-input v-model="form.bankAccountNumber"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Bank Account Name">
                  <b-form-input v-model="form.bankAccountName"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </section>
        </b-col>
      </b-row>

      <template v-if="activeTab == 'contact'">
        <FormVendorListContact
      /></template>
      <template v-if="activeTab == 'document'">
        <FormVendorDocument
      /></template>

      <!-- Buttons -->
      <b-row class="mt-4">
        <b-col cols="6">
          <b-button
            variant="outline-primary"
            class="w-100"
            @click="$emit('close')"
            >Cancel & Close</b-button
          >
        </b-col>
        <b-col cols="6">
          <b-button type="submit" variant="primary" class="w-100"
            >Submit</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import FormVendorListContact from './FormVendorListContact.vue'
import FormVendorDocument from './FormVendorDocument.vue'
import CustomNav from '@/src/components/global/CustomNav.vue'

export default {
  name: 'FormVendorCandidate',
  components: { FormVendorListContact, FormVendorDocument, CustomNav },
  data() {
    return {
      tabs: [
        { label: 'General', value: 'general' },
        { label: 'Contact', value: 'contact' },
        { label: 'Support Document', value: 'document' },
      ],
      activeTab: 'general',
      form: {
        accountName: '',
        vendorClass: '',
        vendorCategory: '',
        vendorStatus: '',
        country: '',
        province: '',
        city: '',
        district: '',
        subDistrict: '',
        postalCode: '',
        address: '',
        terms: '',
        currency: '',
        logo: null,
        web: '',
        picName: '',
        picJobTitle: '',
        emailOffice: '',
        email: '',
        phone: '',
        mobile: '',
        npwp: '',
        sktd: '',
        nib: '',
        bank: '',
        bankAccountNumber: '',
        bankAccountName: '',
      },
      vendorClassOptions: ['Purchasing', 'Supplier', 'Contractor'],
      vendorCategoryOptions: ['Local', 'International'],
      vendorStatusOptions: ['Active', 'Requested', 'Blacklist'],
      countryOptions: ['Indonesia (ID)', 'Malaysia', 'Singapore'],
      currencyOptions: ['IDR', 'USD', 'EUR'],
      bankOptions: ['Bank BCA', 'Bank Mandiri', 'Bank BNI'],
      contacts: [
        {
          selected: false,
          name: 'Andi Pratama',
          department: 'Purchasing',
          jobTitle: 'Purchasing Manager',
          email: 'andi.pratama@sinarlaut.co.id',
          phone: '',
          mobile: '081234567890',
        },
        {
          selected: true,
          name: 'Siti Rahmawati',
          department: 'Operational',
          jobTitle: 'Operational Head',
          email: 'siti@maju-bersama.co.id',
          phone: '',
          mobile: '082345678901',
        },
      ],
      fields: [
        { key: 'selected', label: '', thStyle: { width: '40px' } },
        { key: 'name', label: 'Name' },
        { key: 'department', label: 'Department' },
        { key: 'jobTitle', label: 'Job Title' },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'mobile', label: 'Mobile Phone' },
        { key: 'actions', label: '', thStyle: { width: '40px' } },
      ],
      selectAll: false,
    }
  },
  methods: {
    onSubmit() {
      alert('Form submitted!')
    },
  },
}
</script>

<style scoped>
.section-title {
  position: relative;
  width: 100%;
  border-bottom: 2px solid #334697;
  background: blue;
  margin-bottom: 20px;
}

.section-title h6 {
  color: #273469;
  font-weight: 600;
  background: white;
  position: absolute;
  top: -12px;
  padding-right: 20px;
}
</style>
